// apps/client/src/state/store.ts
import { create, type StoreApi, type UseBoundStore } from 'zustand';
import { sliceModules } from './slices.gen';
import type { GameStore, SetState } from './types';

/** Object.assign of the slices, but a key returned by two slices is a bug (feature slices prefix their keys, §8.7). */
export function mergeSlices(parts: readonly object[]): GameStore {
  const out: Record<string, unknown> = {};
  for (const part of parts) for (const [k, v] of Object.entries(part)) {
    if (k in out) throw new Error(`duplicate store key: ${k}`);
    out[k] = v;
  }
  return out as unknown as GameStore;
}
export const useGame: UseBoundStore<StoreApi<GameStore>> = create<GameStore>()((set, get) =>
  mergeSlices(sliceModules.map((m) => m.slice(set as SetState, get))));
